import e from "./_nativeCreate.js";
var a = e;
function t() {
  this.__data__ = a ? a(null) : {}, this.size = 0;
}
var i = t;
export {
  i as default
};
//# sourceMappingURL=_hashClear.js.map
